    <div class="booking-create">
      <div class="page-header">
        <button mat-icon-button routerLink="/bookings" aria-label="Назад">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="page-title">Новое бронирование</h1>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="booking-form">
        <mat-card class="form-card">
          <mat-card-content>
            <h3 class="section-title">Клиент</h3>
            <app-client-select
              formControlName="client"
              label="Поиск клиента"
              [required]="true">
            </app-client-select>

            <mat-divider class="section-divider"></mat-divider>

            <h3 class="section-title">Автомобиль</h3>
            <app-car-select
              formControlName="car"
              [cars]="availableCars"
              label="Автомобиль"
              [required]="true">
            </app-car-select>

            <mat-divider class="section-divider"></mat-divider>

            <h3 class="section-title">Дата и время</h3>
            <app-datetime-input
              formControlName="startDate"
              dateLabel="Дата начала"
              timeLabel="Время"
              [required]="true">
            </app-datetime-input>

            <app-datetime-input
              formControlName="endDate"
              dateLabel="Дата окончания"
              timeLabel="Время"
              [required]="true">
            </app-datetime-input>

            <mat-divider class="section-divider"></mat-divider>

            <h3 class="section-title">Дополнительно</h3>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Залог, &#8381;</mat-label>
              <input matInput formControlName="depositAmount" type="number">
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Сумма аренды, &#8381;</mat-label>
              <input matInput formControlName="rentalAmount" type="number">
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Заметки</mat-label>
              <textarea matInput formControlName="notes" rows="3"></textarea>
            </mat-form-field>
          </mat-card-content>
        </mat-card>

        <button mat-raised-button color="primary" type="submit" class="full-width-btn submit-btn"
                [disabled]="form.invalid || submitting">
          <mat-spinner *ngIf="submitting" diameter="20"></mat-spinner>
          <span *ngIf="!submitting">Создать бронирование</span>
        </button>
      </form>
    </div>
